import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { useOrderSave } from "../context/OrderSaveContext";
import { showErrorToast } from "../components/toasts/ToastService";

const BelesTipus = () => {
	const { order, updateOrder } = useOrder();
	const navigate = useStepNavigate();
	const [selectedBeles, setSelectedBeles] = useState(order.hmeliorder?.hmeliorder_linermaterial_id || null);
	const [loading, setLoading] = useState(false);
	const { saveOrder } = useOrderSave();
	const linermaterials = order.model_options?.linermaterials_for_model || [];

	const handleSelect = (obj) => {
		setSelectedBeles(obj.liner_material_szam);
		updateOrder({
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_liner_material: obj.liner_material_name,
				hmeliorder_linermaterial_id: obj.liner_material_szam
			}
		});
	};

	const handleBackClick = () => {
		if (order?.hmeliorder?.hmeliorder_sole_type === "forma") {
        navigate("/Talp");
        return;
    } else {
		navigate("/Rama");
		return;
	};
	};



	const handleNext = async () => {
		setLoading(true);

		const updatedOrder = {
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_linermaterial_id: selectedBeles,
				hmeliorder_liner_material: linermaterials.find(l => l.liner_material_szam === selectedBeles)?.liner_material_name || "",
			},
		};

		try {
			updateOrder(updatedOrder);
			const result = await saveOrder(updatedOrder);

			if (result?.success !== false) {
				navigate('/KeregTipus');
			} else {
				showErrorToast(result?.message || 'Hiba történt a rendelés mentése során!');
			}
		} catch (err) {
			showErrorToast('Hiba történt a rendelés mentése során: ' + (err?.message || err));
		} finally {
			setLoading(false);
		}
	};

	const canProceed = selectedBeles > 1;

	if (!linermaterials.length) {
		return (
			<TablerLayout title="Bélés típus kiválasztása">
				<div className="text-center">
					<div className="alert alert-warning">
						Nincs elérhető bélés típus ehhez a modellhez!
						<br />
						Kérem, lépjen vissza és válasszon másik modellt!
					</div>
				</div>
			</TablerLayout>
		);
	}

	return (
		<TablerLayout title="Bélés típus kiválasztása">
			<div className="row justify-content-center">
				<div className="col-md-10">
					<div className="card-body">
						<div className="row g-4 justify-content-center">
							{linermaterials.map((belesTipus) => (
								<div className="col-12 col-sm-6 col-lg-6" key={belesTipus.liner_material_szam}>
									<button
										type="button"
										className={`btn w-100 py-4 px-3 shadow-sm rounded-4 d-flex flex-column align-items-center fw-bold
											${belesTipus.disabled 
												? "btn-outline-secondary text-muted border-secondary bg-light" 
												: selectedBeles === belesTipus.liner_material_szam 
													? "btn-primary" 
													: "btn-outline-primary text-primary border-primary bg-white"}`}
										style={{
											fontSize: 20,
											fontWeight: 600,
											borderWidth: 2,
											minHeight: 100,
											cursor: belesTipus.disabled ? "not-allowed" : "pointer"
										}}
										onClick={() => !belesTipus.disabled && handleSelect(belesTipus)}
										disabled={belesTipus.disabled}
										title={belesTipus.disabled ? "Ez a bélés típus nem elérhető ehhez a modellhez" : ""}
									>
										<span>{belesTipus.liner_material_name}</span>
									</button>
								</div>
							))}
						</div>
					</div>
					
				</div>
			</div>
			<div className="card-footer d-flex justify-content-between">
						<StepperNavButton
							side="left"
							label="Vissza"
							onClick={handleBackClick}
						/>
						<StepperNavButton
							side="right"
							label="Tovább"
							onClick={handleNext}
							disabled={!canProceed || loading}
						/>
					</div>
		</TablerLayout>
	);
};

export default BelesTipus;